
import { createFallbackUpdateNodeData } from "./NodeFallbacks";
import type { FlowNodeData, FlowNodeState } from "./FlowNodeTypes";
import type { NodeShape } from "@/utils/shapeUtils";

export const validateFlowNodeProps = (id: string, data: FlowNodeData) => {
  // Early validation with better error handling
  if (!id || typeof id !== 'string') {
    console.error("FlowNode: Invalid id provided:", id);
    return { isValid: false, error: "Invalid node ID" };
  }

  if (!data || typeof data !== 'object') {
    console.error("FlowNode: Invalid data provided:", data);
    return { isValid: false, error: "Invalid node data" };
  }

  return { isValid: true, error: null };
};

export const prepareFlowNodeState = (data: FlowNodeData): FlowNodeState => {
  // Safely get dimensions with fallbacks
  const nodeWidth = (typeof data.width === 'number' && data.width > 0) ? data.width : 250;
  const nodeHeight = (typeof data.height === 'number' && data.height > 0) ? data.height : 150;
  
  // Get current shape from data, ensuring it updates when data changes
  const currentShape: NodeShape = data.shape || "rectangle";
  
  // Check for updateNodeData function with better fallback
  let updateNodeData = data.updateNodeData;
  if (typeof updateNodeData !== 'function') {
    console.warn("No updateNodeData function provided, using fallback");
    updateNodeData = createFallbackUpdateNodeData();
  }

  // Check for recent edits
  const wasRecentlyEdited = Boolean(
    data.lastEdited && 
    typeof data.lastEdited === 'number' &&
    Date.now() - data.lastEdited < 3000 && 
    data.editedBy &&
    typeof data.editedBy === 'string'
  );

  return {
    nodeWidth,
    nodeHeight,
    currentShape,
    updateNodeData,
    wasRecentlyEdited
  };
};
